import { cn } from "cn";
import { NavLink, type To } from "react-router";

type SidebarProps = {
	children?: React.ReactNode;
	className?: string;
};

export const Sidebar: React.FC<SidebarProps> = ({ className, children }) => {
	return (
		<nav className={cn("w-full lg:w-60 shrink-0", className)}>{children}</nav>
	);
};

type SettingsSidebarNavItemProps = {
	children?: React.ReactNode;
	href: To;
	end?: boolean;
};

export const SettingsSidebarNavItem: React.FC<SettingsSidebarNavItemProps> = ({
	children,
	href,
	end,
}) => {
	return (
		<NavLink
			end={end}
			to={href}
			className={({ isActive }) =>
				cn(
					"relative text-sm text-content-secondary no-underline font-medium py-2 px-3 hover:bg-surface-secondary rounded-md transition ease-in-out duration-150",
					isActive && "font-semibold text-content-primary",
				)
			}
		>
			{children}
		</NavLink>
	);
};
